
import Vue from 'vue';
import { mapState } from 'vuex';
import PublicPortfolioRecommendedUser from '~/components/partials/public-portfolio/PublicPortfolioRecommendedUsers/PublicPortfolioRecommendedUser.vue';

export default Vue.extend({
  name: 'PublicPortfolioRecommendedUsersSection',
  components: { PublicPortfolioRecommendedUser },
  computed: {
    ...mapState('portfolio', ['topUsers']),
  },
});
